<ng-select
  [items]="grades$ | async"
  bindLabel="grade_Descr"
  bindValue="jobCode"
  [searchable]="true"
  [clearable]="true"
  placeholder="Select Grade"
  [formControl]="fc">

  <ng-template ng-option-tmp let-item="item">
    {{ item.grade_Descr }}
  </ng-template>

  <!-- <ng-template ng-notfound-tmp>
    No grades found
  </ng-template> -->
</ng-select>
